import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title1: "",
  title2: "",
  imageSrc: "",
  primaryButtonTitle: "",
  primaryButtonOnClick: () => {},
  secondaryButtonTitle: "",
  secondaryButtonOnClick: () => {},
  disableClose: false,
};

const generalDialogSlice = createSlice({
  name: "generalDialog",
  initialState,
  reducers: {
    openGeneralDialogModal: (state, action) => {
      state.isOpen = action.payload.isOpen;
      state.disableClose = action.payload.disableClose;
      state.title1 = action.payload.title1;
      state.title2 = action.payload.title2;
      state.imageSrc = action.payload.imageSrc;
      state.primaryButtonTitle = action.payload.primaryButtonTitle;
      state.primaryButtonOnClick = action.payload.primaryButtonOnClick;
      state.secondaryButtonTitle = action.payload.secondaryButtonTitle;
      state.secondaryButtonOnClick = action.payload.secondaryButtonOnClick;
    },
    closeGeneralDialogModal: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openGeneralDialogModal, closeGeneralDialogModal } =
  generalDialogSlice.actions;
export default generalDialogSlice.reducer;
